import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api';
import DatenschutzCheckbox from '../components/DatenschutzCheckbox';
import Erfolgsmeldung from '../components/Erfolgsmeldung';
import FormularFelder, { useKachelFormular, validiereFelder, trenneWerte } from '../components/FormularFelder';

export default function GenericFormular() {
  const { key } = useParams();
  const navigate = useNavigate();
  const { laden, fehler: ladeFehler, kachel } = useKachelFormular(key);

  const [werte, setWerte] = useState({});
  const [datenschutz, setDatenschutz] = useState(false);
  const [website, setWebsite] = useState('');

  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  if (laden) return (
    <div className="form-container">
      <div style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>Lädt…</div>
    </div>
  );

  if (ladeFehler || !kachel || kachel.typ !== 'formular_custom') return (
    <div className="form-container">
      <button className="back-btn" onClick={() => navigate('/')}>← Zurück</button>
      <p style={{ color: '#c62828', textAlign: 'center', padding: '2rem' }}>
        Dieses Formular ist nicht verfügbar.
      </p>
    </div>
  );

  const felder = kachel.formular_felder || [];

  const setzeWert = (id, wert) => {
    setWerte(prev => ({ ...prev, [id]: wert }));
    if (errors[id]) setErrors(prev => ({ ...prev, [id]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (website) return; // honeypot

    const errs = validiereFelder(felder, werte);
    if (!datenschutz) errs.datenschutz = 'Datenschutz muss akzeptiert werden';
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    setSubmitting(true);
    setServerError('');
    try {
      // Name/E-Mail unter ihren festen Schlüsseln, Zusatzfelder unter ihrer Beschriftung
      const { system, zusatz } = trenneWerte(felder, werte);
      if (typeof system['E-Mail'] === 'string') system['E-Mail'] = system['E-Mail'].toLowerCase();
      await api.post(`/api/kacheln/${key}/submit`, {
        felder: { ...system, ...zusatz },
        datenschutz_akzeptiert: true,
      });
      setSuccess(true);
    } catch (err) {
      setServerError(err.response?.data?.error || 'Fehler beim Senden. Bitte später erneut versuchen.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <Erfolgsmeldung
        titel="Vielen Dank!"
        text={kachel.bestaetigung_text || 'Deine Anfrage wurde erfolgreich übermittelt. Wir melden uns bei dir.'}
      />
    );
  }

  return (
    <div className="form-container">
      <button className="back-btn" onClick={() => navigate('/')}>← Zurück</button>
      <h2 className="form-title">{kachel.titel}</h2>
      {kachel.beschreibung && (
        <p style={{ color: '#666', marginBottom: '1.5rem', lineHeight: 1.5 }}>{kachel.beschreibung}</p>
      )}

      {serverError && <div className="alert alert-error">{serverError}</div>}

      <form onSubmit={handleSubmit} noValidate>
        <div className="honeypot" aria-hidden="true">
          <input type="text" value={website} onChange={e => setWebsite(e.target.value)} tabIndex="-1" autoComplete="off" />
        </div>

        <FormularFelder felder={felder} werte={werte} fehler={errors} onChange={setzeWert} />

        <DatenschutzCheckbox
          checked={datenschutz}
          onChange={e => { setDatenschutz(e.target.checked); if (errors.datenschutz) setErrors(p => ({ ...p, datenschutz: '' })); }}
          error={errors.datenschutz}
        />

        <button type="submit" className="submit-btn" disabled={submitting}>
          {submitting ? 'Wird gesendet…' : 'Absenden'}
        </button>
      </form>
    </div>
  );
}
